<template>
			<div id="page-content" class="admin-sidebar">
				<div class="component-padding">
					
					<button class="button-type-f text-left" type="button">Export Spreadsheet</button>
					
					<div id="products-admin-options">
						<h1>Suppliers</h1>
						<div>
							<input type="text" placeholder="Search Supplier">
							<select name="fabrianne">
								<option value="">Sort By</option>
								<option value="">Company</option>
								<option value="">Contact Person</option>
								<option value="">PO Format</option>
							</select>
						</div>
					</div>
					
					<table class="admin-table">
							<tr>
								<th>Company</th>
								<th>Email</th> 
								<th>Contact #</th>
								<th>Contact Person</th>
								<th>PO Format</th>
								<th>Options</th>
							</tr>
							<tr v-for="n in 14">
								<td>Phelix Systems</td>
								<td>Phelix@email.com</td> 
								<td>09986573838</td>
								<td>Phelix Max</td>
								<td>AST</td>
								<td class="admin-table-row-options">
									<button>Edit Account</button>
									<button>Delete Account</button>
								</td>
							</tr>
					</table>
					
					<button class="button-type-f text-left" type="button">Export Spreadsheet</button>
				</div>
			</div>
</template>

<script>
	export default{
		data(){
			return{

			}
		},
		mounted(){
			relativeTo('nav', this.$el);
		}
	}
</script>


// WEBPACK FOOTER //
// AdminSuppliers.vue?bbc7770a